import { Grid } from '@mui/material';
import classNames from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { SocialProofData } from 'types/cms.types';

import { Country } from '../../config';
import { useLanguage } from '../../hooks/useLanguage';
import { usePriceFormatter } from '../../hooks/usePriceFormatter';
import BlockTitle from '../layout/BlockTitle/BlockTitle';

type SocialProofProps = {
  lightTheme?: boolean;
  statistics?: SocialProofData;
};

export const SocialProof = ({ lightTheme, statistics }: SocialProofProps) => {
  const { t } = useTranslation();
  const { country } = useLanguage();
  const formatPrice = usePriceFormatter();

  const itemClass = (value?: number) =>
    classNames('hp_social_proof-item', {
      'hp_social_proof-item--hidden': !value,
    });

  return (
    <div className={`hp_social_proof ${lightTheme && 'hp_social_proof--light'}`}>
      <Grid container justifyContent="center" alignItems="center">
        <div className={itemClass(statistics?.totalRegisteredUsers)}>
          <BlockTitle mb={0} mt={1}>
            {formatPrice(statistics?.totalRegisteredUsers, {
              type: 'decimal',
              disableCurrency: true,
            })}
          </BlockTitle>
          <p className="hp_social_proof-subtext mb-1">{t('components.social-proof.users')}</p>
        </div>
        <div className={itemClass(statistics?.productsSold)}>
          <BlockTitle mb={0} mt={1}>
            {formatPrice(statistics?.productsSold, {
              type: 'decimal',
              disableCurrency: true,
            })}
          </BlockTitle>
          <p className="hp_social_proof-subtext mb-1">{t('components.social-proof.products-sold')}</p>
        </div>
        <div className={itemClass(statistics?.rating)}>
          <BlockTitle mb={0} mt={1}>
            <img
              src={lightTheme ? '/icons/icn-hellopeter-score-white.svg' : '/icons/icn-hellopeter-score.svg'}
              className="hp_social_proof-hellopeter-score"
              alt="Hellopeter score"
            />
          </BlockTitle>
          <p className="hp_social_proof-subtext mb-1">
            {statistics?.rating}
            {country === Country.ZA ? (
              <>
                <img
                  src={lightTheme ? '/icons/icn-hellopeter-white.svg' : '/icons/icn-hellopeter.svg'}
                  className="hp_social_proof-hellopeter-logo"
                  alt="hellopeter"
                />
              </>
            ) : (
              <>{t('components.social-proof.app-store')}</>
            )}
          </p>
        </div>
      </Grid>
    </div>
  );
};
